<script setup lang="ts">
import { ScrollAreaCorner, ScrollAreaRoot, type ScrollAreaRootProps, ScrollAreaViewport } from "reka-ui"

export interface UiScrollAreaClasses {
  root?: ClassValue
  viewport?: ClassValue
  scrollbar?: ClassValue
}

export interface UiScrollArea extends ScrollAreaRootProps {
  alwaysShowScrollBar?: boolean
  class?: ClassValue
  classes?: UiScrollAreaClasses
}
const props = defineProps<UiScrollArea>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <ScrollAreaRoot v-bind="delegatedProps" :class="cn('relative overflow-hidden', classes?.root, props.class)">
    <ScrollAreaViewport :class="cn('h-full w-full rounded-[inherit]', classes?.viewport)" as-child>
      <slot />
    </ScrollAreaViewport>
    <UiScrollAreaScrollBar :class="classes?.scrollbar" :force-mount="alwaysShowScrollBar" />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
